import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import KeyServices from "./pages/KeyServices";
import Lockouts from "./pages/Lockouts";
import Emergency from "./pages/Emergency";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/key-services" element={<KeyServices />} />
          <Route path="/lockouts" element={<Lockouts />} />
          <Route path="/emergency" element={<Emergency />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
